export enum LocalStorageKey {
  SESSION_TOKEN = 'authorization',
  AUTHORIZATION_URL_PARAM = 'authorization-url-params',
  LOGIN_QUERY_STRING = 'login-query-string',
}
